import React, { ReactNode, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Alumni, ANGKATAN_PERTAMA } from 'iasma-datatypes';
import { IASMAContext, IASMAContextType, MergeRecord } from './IASMAContext';
import { useAuth } from '../AuthContext';
import { useNotify } from '../NotifyContext';
import { queryAlumniList } from '@/services/DirectoryService';

interface IASMAProviderProps {
	children: ReactNode;
}

export const IASMAProvider: React.FC<IASMAProviderProps> = ({ children }) => {
	const { setToken } = useAuth()
	const { setNotify } = useNotify();

	const [angkatan, setAngkatan] = useState<number>(0)
	const [alumniList, setAlumniList] = useState<Alumni[]>([])
	const [mergeRecord, setMergeRecord] = useState<MergeRecord | undefined>(undefined);

	useEffect(() => {
		const fetchAlumniList = async () => {
			if(angkatan >= ANGKATAN_PERTAMA) {
				try {
					setToken(axios);
					const recs: Alumni[] = await queryAlumniList(angkatan);
					setAlumniList(recs);
				} catch (error: any) {
					setNotify({
						title: "Error Fetching AlumniList",
						error,
						severity: 'error',
					});
				}
			}
		};
		fetchAlumniList()		
	}, [angkatan]);
	
	const value: IASMAContextType = {
		angkatan,
		setAngkatan,
		alumniList,
		setAlumniList,
		mergeRecord,
		setMergeRecord		
	};

	return <IASMAContext.Provider value={value}>{children}</IASMAContext.Provider>;
};

export const useIASMAContext = () => useContext(IASMAContext);